import styled from "styled-components";

export default styled.aside`
    color: #889;
    font-size: .8em;
    margin: 2px 0;
`;
